'use client'

import { cn } from '@/utils/ui'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'
import * as React from 'react'

const Checkbox: React.FC<
  {
    ref?: React.Ref<HTMLButtonElement>
    hasError?: boolean
  } & React.ComponentProps<typeof CheckboxPrimitive.Root>
> = ({ className, ref, hasError = false, ...props }) => (
  <CheckboxPrimitive.Root
    className={cn(
      `peer h-4 w-4 shrink-0 rounded-sm border ${hasError ? `border-border-error bg-bg-error` : `border-border-input bg-bg-base`} ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2 focus:border-2 focus:border-border-focus disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-bg-intense data-[state=checked]:text-primary-foreground`,
      className,
    )}
    ref={ref}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="h-3 w-3" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
)

export { Checkbox }
